/*
# -----------------------------------------------------------------------------
# Component: marineCargoDataMixin.js
# Author: cyy@pst.sg
# Created Date: 12/Mac/2020
# Comments: Responsible for shared components - Marine Cargo Parameters
# -----------------------------------------------------------------------------
*/

import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export const marineCargoDataMixin = {
  data() {
    return {
      sideFunction: [
        // {
        //   text: 'Marine Cargo Commodity',
        //   icon: 'mdi-tune',
        //   iconColor: 'primary',
        //   params: { name: 'marineCargoComdty' }
        // },
        {
          text: 'Marine Cargo Conveyance Type',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'marineCargoConveyance' }
        },
        {
          text: 'Marine Cargo Date',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'marineCargoVoyageDate' }
        },
        {
          text: 'Marine Cargo Packing Type',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'marineCargoPack' }
        },
        {
          text: 'Marine Cargo Port',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'marineCargoPort' }
        },
        {
          text: 'Marine Cargo Voyage Area',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'marineCargoVoyage' }
        }
      ]
    }
  },
  methods: {
    doInit(pKey) {
      const apiURI = this.menu.marineCargoParamList
      if (apiURI) {
        const params = {
          paramKey: pKey,
          paramString: ''
        }
        this.loading = true
        this.$http.get(expandURI(apiURI, params)).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(result => {
              const convertList = {
                paramName: result.paramName,
                paramType: result.paramType,
                paramDesc: result.paramDesc
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    }
  },
  components: {
    SideFunctionMenu
  },
  computed: {
    menu() {
      return this.$store.state.marineCargoParam.menu
    }
  },
  mixins: [
    MessageMixin
  ]
}
